import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 32px 20px 20px 20px;
  border-radius: 8px;
  background: ${({ theme }) => theme.COLORS.LightWhite};
`;
